<template>
  <div :class="['global-auth-box d-flex justify-center align-center', {hide:!show}]" @click="close">
    <div class="g-auth-box" @click.stop>
      <div class="page-title" v-if="!showSuccess">Corporate Sign Up</div>
      <div class="instruction-txt" v-if="!showSuccess">
        <span v-if="step === 1">Please fill in this form to create an account </span>
        <span v-else-if="step === 2">Billing Information </span>
        <span v-else>Review your details </span>
        <!-- ({{step}}/3) -->
      </div>

      <div v-show="step === 1 && !showSuccess">
        <div class="d-flex accnt-fields">
          <div class="cor-acc-fields">
            <div class="cor-fields">
              <div class="cf-label">Username ({{username.length}}/30)</div>
              <input type="text" class="cf-input" v-model="username" maxlength="30" @change="revalidate('username')" />
              <div class="error-msg" v-if="validation.username">{{ validation.username }}</div>
            </div>
            <div class="cor-fields">
              <div class="cf-label">Password  ({{password.length}}/30)</div>
              <input type="password" class="cf-input" v-model="password" maxlength="30" @change="revalidate('password')" />
              <div class="error-msg" v-if="validation.password">{{ validation.password }}</div>
            </div>
            <div class="cor-fields">
              <div class="cf-label">Repeat Password  ({{rpassword.length}}/30)</div>
              <input type="password" class="cf-input" v-model="rpassword" maxlength="30" @change="revalidate('rpassword')" />
              <div class="error-msg" v-if="validation.rpassword">{{ validation.rpassword }}</div>
            </div>
          </div>

          <div :class="['cor-img-box', {loading:img.loading}]" @click="$refs.fileUpload.click()">
            <div class="cor-img">
              <div class="ci-txt">Recommended Size: 200px by 200px</div>
              <img :src="img.src" v-if="img.src" alt="Upload Corporate Logo">
              <i class="fas fa-user-circle fa-fw" v-else></i>
              <transition name="slide-up">
                <i class="fa fa-spinner fa-spin fa-fw" v-show="img.loading"></i>
              </transition>
            </div>
            <div class="img-error" v-if="response.show">{{ response.message }}</div>
            <input type="file" ref="fileUpload" v-show="false" @change="uploadFile" />
          </div>
        </div>

        <div class="cor-fields">
          <div class="cf-label">Mobile Number</div>
          <mobile-input :needVerification="false" :mobile="mobile" :uniqID="'mobile1'"
            @updateMobile="updateMobileInfo" ref="userMobile" :dialCode="countryCode"
            :required="true" :hasError="error.fields.indexOf('mobile') > -1"
            :noMB="true"
          ></mobile-input>
          <div class="error-msg" v-if="validation.mobile">{{ validation.mobile }}</div>
        </div>

        <div class="cor-fields">
          <div class="cf-label">Corporate Name</div>
          <input type="text" class="cf-input" v-model="corpName" @change="revalidate('corpName')" />
          <div class="error-msg" v-if="validation.corpName">{{ validation.corpName }}</div>
        </div>

        <div class="d-flex multi-row">
          <div class="cor-fields">
            <div class="cf-label">Email</div>
            <input type="text" class="cf-input" v-model="email" @change="revalidate('email')" />
            <div class="error-msg" v-if="validation.email">{{ validation.email }}</div>
          </div>
          <div class="cor-fields">
            <div class="cf-label">Website</div>
            <input type="text" class="cf-input" v-model="website" @change="revalidate('website')" />
            <div class="error-msg" v-if="validation.website">{{ validation.website }}</div>
          </div>
        </div>
      </div>

      <div v-show="step === 2 && !showSuccess">
        <div class="cor-fields">
          <div class="cf-label">Card Info</div>
          <div id="card-element"></div>
          <div class="error-msg" v-if="validation.cardInfo">{{ validation.cardInfo }}</div>
        </div>

        <div class="cor-fields">
          <div class="cf-label">Cardholder Name</div>
          <input type="text" class="cf-input" placeholder="i.e. John Appleseed" v-model="card.cardName" />
        </div>
        <div class="cor-fields">
          <div class="cf-label">Billing Address</div>
          <input type="text" class="cf-input" v-model="card.billingAddress" @change="revalidate('billingAddress')" />
          <div class="error-msg" v-if="validation.billingAddress">{{ validation.billingAddress }}</div>
        </div>
        <div class="cor-fields">
          <div class="cf-label">City</div>
          <input type="text" class="cf-input" v-model="card.billingCity" @change="revalidate('billingCity')" />
          <div class="error-msg" v-if="validation.billingCity">{{ validation.billingCity }}</div>
        </div>
        <div class="cor-fields">
          <div class="cf-label">State</div>
          <select class="cf-select" v-model="card.billingState" v-on:change="onStateSelect">
            <option disabled value="-1">{{ $t('payment.chooseOne') }}</option>
            <option v-for="state in states" v-bind:value="state.value">{{ state.name }}</option>
          </select>
          <div class="error-msg" v-if="validation.billingState">{{ validation.billingState }}</div>
        </div>
        <div class="cor-fields" v-show="showCountry">
          <div class="cf-label">Country</div>
          <select class="cf-select" v-model="card.billingCountry">
            <option disabled value="-1">{{ $t('payment.chooseOne') }}</option>
            <option v-for="country in countries" :value="country.value">{{ country.name }}</option>
          </select>
          <div class="error-msg" v-if="validation.billingCountry">{{ validation.billingCountry }}</div>
        </div>
      </div>

      <div v-show="step ===3 && !showSuccess">
        <div class="inf-box">
          <div class="inf-row d-flex">
            <div class="inf-label">Corporate Name:</div>
            <div class="inf-value">{{ corpName }}</div>
          </div>
          <div class="inf-row d-flex">
            <div class="inf-label">Username:</div>
            <div class="inf-value">{{ username }}</div>
          </div>
          <div class="inf-row d-flex">
            <div class="inf-label">Email:</div>
            <div class="inf-value">{{ email }}</div>
          </div>
          <div class="inf-row d-flex">
            <div class="inf-label">Mobile Number:</div>
            <div class="inf-value">+{{ countryCode }}{{ mobile }}</div>
          </div>
          <div class="inf-row d-flex">
            <div class="inf-label">Website:</div>
            <div class="inf-value">{{ website }}</div>
          </div>
        </div>

        <div class="inf-box">
          <div class="inf-row d-flex">
            <div class="inf-label">Address:</div>
            <div class="inf-value">{{ `${card.billingAddress} ${card.billingCity}, ${card.billingState}` }}</div>
          </div>
        </div>
      </div>

      <div v-if="showSuccess">
        <div class="checkmark-circle">
          <div class="background"></div>
          <div class="checkmark draw start"></div>
        </div>
        <div class="success-msg">
          <b>{{ $t('searchForm.thankYouSignup') }}</b>
          {{ $t('searchForm.yourCorporate') }}
        </div>

        <div class="lr-btn secondary" @click="close">Close</div>
      </div>

      <div class="d-flex action-box justify-space-between" v-if="!showSuccess">
        <div class="lr-btn secondary" @click="back">Back</div>
        <div class="lr-btn" @click="next">Submit</div>
      </div>
    </div>
  </div>
</template>

<script>
/* global CONFIG */
import US from 'us'
import uuidv4 from 'uuid/v4'
import Countries from '@/data/countries.js'
import mobileInput from '@/components/D2DOthers/MobileInput'

export default {
  name: 'auth-signup-corporate',
  components: { mobileInput },
  data () {
    return {
      step: 1,
      img: {
        loading: false,
        src: ''
      },
      username: '',
      password: '',
      rpassword: '',
      countryCode: 1,
      mobile: '',
      corpName: '',
      email: '',
      website: '',
      card: {
        cardName: '',
        billingAddress: '',
        billingCity: '',
        billingState: '-1',
        billingCountry: '-1'
      },
      showCountry: false,
      validation: {
        username: '',
        password: '',
        rpassword: '',
        mobile: '',
        corpName: '',
        email: '',
        website: '',
        cardInfo: '',
        billingAddress: '',
        billingCity: '',
        billingState: '',
        billingCountry: ''
      },
      error: {
        fields: [],
        msg: []
      },
      response: {
        show: false,
        success: false,
        message: ''
      },
      showSuccess: false
    }
  },
  computed: {
    user () { return this.$store.state.user },
    auth () { return this.$store.state.global.auth },
    show: {
      get () { return this.$store.state.global.auth.showCorporate },
      set (x) {
        this.step = 1
        if (this.auth.action === 'forceAuth') return
        this.$store.commit('global/setAuthData', {showCorporate: x})
      }
    },
    states () {
      let result = []
      result.push({
        name: 'Non US',
        value: ''
      })
      let states = US.STATES
      for (let i = 0; i < states.length; i++) {
        result.push({
          name: states[i].name,
          value: states[i].abbr
        })
      }
      return result
    },
    countries () {
      let result = []
      for (let property in Countries) {
        if (!Countries.hasOwnProperty(property)) { continue }
        if (property === 'us') { continue }
        result.push({
          name: Countries[property].name,
          value: property.toUpperCase()
        })
      }
      return result
    }
  },
  methods: {
    close () {
      this.show = false
      this.error.fields = []
      this.error.msg = []
      this.step = 1
      this.showSuccess = false
    },
    back () {
      this.close()
      this.$store.commit('global/setAuthData', {
        signupSelect: true,
        showCorporate: false
      })
      // this.$store.commit('global/setAuthData', {signupSelect: true})
    },
    uploadFile (e) {
      if (!e.target.files.length) return

      let self = this
      let file = e.target.files[0]
      let fd = new FormData()
      fd.append('pic', file)

      self.img.loading = true
      self.$http.post(CONFIG.mediaHost + '/api/upload', fd, {
        header: {'Content-Type': 'multipart/form-data'}
      }).then(function (res) {
        self.img.loading = false
        if (!res.body.success) {
          self.img.src = ''
          self.response = {
            show: true,
            success: false,
            message: 'Image upload failed. Please try again or use a different image.'
          }
          return
        }

        self.img.src = res.body.data.url
        self.response.show = false
        self.response.message = ''
      }, function (res) {
        self.response = {
          show: true,
          success: false,
          message: res
        }
      })
    },
    updateMobileInfo (val) {
      this.mobile = val.mobile
      this.countryCode = val.countryCode
      this.revalidate('mobile')
    },
    revalidate (x) {
      if (['password', 'rpassword'].indexOf(x) > -1 && this.password && this.rpassword && this.password !== this.rpassword) {
        this.validation.rpassword = 'Repeat password doesnt match password.'
        if (x === 'password' && this[x]) this.validation[x] = ''
        return
      }
      if (this.validation[x] && this[x]) this.validation[x] = ''
    },
    onStateSelect () {
      this.showCountry = this.card.billingState === ''
      if (this.showCountry) {
        this.card.billingCountry = '-1'
      }
    },
    next () {
      let self = this
      let hasError = false
      if (self.step === 1) {
        let fields = [
          'username', 'password', 'rpassword',
          'mobile', 'corpName', 'email',
          'website'
        ]
        fields.forEach(x => {
          if (!self[x]) {
            self.validation[x] = 'This field cannot be empty.'
            hasError = true
          } else {
            self.validation[x] = ''
          }
        })
        if (!self.img.src) {
          self.response.show = true
          self.response.message = 'Select upload an image.'
          hasError = true
        }
        if (self.password && self.rpassword && self.password !== self.rpassword) {
          self.validation.rpassword = 'Repeat password doesnt match password.'
          hasError = true
        }
        if (hasError) return

        // self.step++
        self.submitCorp()
        return
      }
      if (self.step === 2) {
        let stripeElmnt = document.getElementById('card-element')
        if (!stripeElmnt.classList.contains('StripeElement--empty')) {
          self.validation.cardInfo = 'Please provide card info'
          hasError = true
        } else if (!stripeElmnt.classList.contains('StripeElement--complete')) {
          self.validation.cardInfo = 'Please fill up card info'
          hasError = true
        }
        if (!self.card.billingAddress) {
          self.validation.billingAddress = 'This field cannot be empty.'
          hasError = true
        }
        if (!self.card.billingCity) {
          self.validation.billingCity = 'This field cannot be empty.'
          hasError = true
        }
        if (self.card.billingState === '-1') {
          self.validation.billingState = 'Please select a state'
          hasError = true
        }
        if (self.card.billingState === 1 && self.card.billingCountry === -1) {
          self.validation.billingCountry = 'Please select a country'
          hasError = true
        }
        console.log('has error', hasError)
        // self.step = 3
      }
    },
    submitCorp () {
      let self = this
      self.$store.commit('global/setLoaderData', {show: true})
      let token = 'CORP-' + uuidv4()
      let mobile = '+' + self.countryCode + self.mobile
      self.$sdk.post(self, '/auth/signup/corporate/d2d', {
        token: token,
        logoUrl: self.img.src,
        name: self.corpName,
        username: self.username,
        password: self.password,
        contactEmail: self.email,
        contactPhone: mobile,
        corporateColor: '#000000',
        corporateWebsiteUrl: self.website,
        active: false,
        d2d: 1
      }, res => {
        self.$store.commit('global/setLoaderData', {show: false})
        if (res.error) {
          self.$store.commit('global/setAlertData', {show: true, message: res.error})
          return
        }
        self.showSuccess = true
        if (self.auth.action && self.auth.action !== 'forceAuth') {
          self.$router.push(self.auth.action)
          self.$store.commit('global/setAuthData', {action: ''})
        }
      })
    }
  },
  mounted () {
    this.stripe = Stripe(CONFIG.stripe.publishableKey) // eslint-disable-line
    let elements = this.stripe.elements({
      fonts: [{cssSrc: 'https://fonts.googleapis.com/css2?family=Questrial&display=swap'}]
    })
    this.cardElement = elements.create('card')
    this.cardElement.mount('#card-element')
  }
}
</script>

<style lang="scss" scoped>
@import "../../assets/scss/Review/ThankYou.scss";

.global-auth-box{
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100vh;
  background: rgba(0,0,0, .3);
  z-index: 2;

  .g-auth-box{
    background: #f9f9f9;
    border-radius: 4px;
    box-shadow: 2px 2px 4px rgba(0,0,0, .3);
    padding: 20px;
    width: 100%;
    max-width: 520px;
    text-align: center;
    -webkit-transition: all 0.1s ease;
    -moz-transition: all 0.1s ease;
    -o-transition: all 0.1s ease;
    transition: all 0.1s ease;
  }
  &.hide {
    z-index: -1;
    opacity: 0;
    display: none !important;

    .g-auth-box{
      transform: scale(90%) translateY(30px);
    }
  }
}
.page-title{
  font-size: 21px;
  font-weight: 600;
  line-height: 1;
  margin-bottom: 20px;
  letter-spacing: .6px;
}
.instruction-txt{
  font-size: 14px;
  color: #777;
  letter-spacing: .6px;
  line-height: 1;
  border-bottom: 2px solid #ddd;
  padding-bottom: 10px;
  margin-bottom: 25px;
}

.accnt-fields{
  gap: 20px;
}
.cor-img-box{
  width: 180px;
  flex: 0 0 180px;
}
.cor-img{
  width: 180px;
  height: 180px;
  background: #fafafa;
  border: 2px dashed #ccc;
  cursor: pointer;
  position: relative;

  &:hover{
    background: #fff;
  }
  .ci-txt{
    line-height: 1.2;
    letter-spacing: .5px;
    font-size: 14px;
    margin: 10px 0;
  }
  .fa-user-circle{
    font-size: 100px;
    color: #9fadbb;
  }
  .fa-spinner{
    position: absolute;
    font-size: 50px;
    z-index: 3;
    top: calc(50% - 25px);
    left: calc(50% - 30px);
    line-height: 1;
    color: #e7b81d;
    text-shadow: 1px 1px 1px rgba(0,0,0, .3);
  }
  img{
    position: absolute;
    top: 0;
    left: 0;
    z-index: 2;
    width: 180px;
    height: 180px;
  }
  &.loading{
    transition: all .2s ease-out;
    .ci-txt, .fa-user-circle, img{
      filter: blur(2px);
    }
  }
}
.img-error{
  line-height: 1.25;
  font-size: 13px;
  letter-spacing: .6px;
  margin-top: 5px;
  color: #f00;
}

.cor-acc-fields{
  width: 100%;
}
.cor-fields{
  margin-bottom: 15px;
  .cf-label{
    text-align: left;
    font-size: 13px;
    color: #586d81;
    letter-spacing: .7px;
    line-height: 1;
    margin-bottom: 2px;
  }
  .cf-input{
    width: 100%;
    padding: 7px;
    line-height: 1;
    letter-spacing: .5px;
    border: 1px solid #ccc;
    font-size: 18px;
    outline: none;
    box-shadow: inset 1px 1px 2px rgba(0, 0, 0, 0.1);
  }
}
.multi-row{
  gap: 20px;

  .cor-fields{
    width: 100%;
  }
}
.error-msg{
  text-align: left;
  line-height: 1;
  font-size: 13px;
  color: #f00;
  letter-spacing: .7px;
  margin-top: 5px;
}

#card-element{
  border: 1px solid #ccc;
  padding: 10px;
  background: #fbfbfb;
  box-shadow: inset 1px 1px 2px rgba(0,0,0,.1);
}

.inf-box{
  background: #efefef;
  padding: 15px 20px;
  margin-bottom: 15px;
  letter-spacing: .6px;
}
.inf-row:not(:last-of-type){
  margin-bottom: 3px;
}
.inf-label{
  color: #6d829b;
  margin-right: 7px;
}
.inf-value{
  font-weight: 600;
  letter-spacing: .7px;
}
.cf-select{
  padding: 5px 7px;
  border: 1px solid #ccc;
  background: #fbfbfb;
  box-shadow: inset 1px 1px 2px rgba(0,0,0,.1);
  font-size: 18px;
}

.action-box{
  margin-top: 20px;
}

.success-msg{
  letter-spacing: .7px;
  margin-bottom: 30px;
  b{
    display: block;
    font-size: 18px;
    margin: 10px 0;
  }
}

.slide-up-enter-active, .slide-up-leave-active { transition: all .3s ease-out; }
.slide-up-enter, .slide-up-leave-to {
  transform: translateY(15px);
  opacity: 0;
}
</style>



// WEBPACK FOOTER //
// GlobalSignupCorporate.vue?3367c386